var map = {
	"./Alpha Bank purchase.png": 661,
	"./Alpha Bank sale.png": 662,
	"./Alpha Bank.png": 663,
	"./American Bank of Investments.png": 664,
	"./BKT.png": 665,
	"./ChartsIcons/Alpha Bank.png": 329,
	"./ChartsIcons/American Bank of Investments.png": 330,
	"./ChartsIcons/BKT.png": 331,
	"./ChartsIcons/Credins Bank.png": 332,
	"./ChartsIcons/First Investment Bank.png": 333,
	"./ChartsIcons/Intesa San Paolo.png": 154,
	"./ChartsIcons/Intesa SanPaolo.png": 334,
	"./ChartsIcons/OTP Bank.png": 335,
	"./ChartsIcons/ProCredit Bank.png": 336,
	"./ChartsIcons/Raiffeisen.png": 155,
	"./ChartsIcons/Tirana Bank.png": 337,
	"./ChartsIcons/Union Bank.png": 338,
	"./ChartsIcons/United Bank of Albania.png": 339,
	"./Credins Bank.png": 666,
	"./First Investment Bank.png": 667,
	"./Intesa SanPaolo purchase.png": 668,
	"./Intesa SanPaolo sale.png": 669,
	"./Intesa SanPaolo.png": 670,
	"./OTP Bank.png": 671,
	"./ProCredit Bank.png": 672,
	"./Raiffeisen purchase.png": 673,
	"./Raiffeisen sale.png": 674,
	"./Raiffeisen.png": 675,
	"./Tirana Bank.png": 676,
	"./Union Bank purchase.png": 677,
	"./Union Bank sale.png": 678,
	"./Union Bank.png": 679,
	"./United Bank of Albania.png": 680,
	"./check-solid.svg": 213,
	"./minus-solid.svg": 214,
	"./times-solid.svg": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;